export default __webpack_public_path__ + "static/media/congrats.ebe2097d.png";